const dev = {
    apiGateway: {
        REGION: "us-east-1",
        ACTIVITYRDS: "https://0eu3a341f8.execute-api.us-east-1.amazonaws.com/prod",
        BOOKSRDS: "https://dzhm8zytul.execute-api.us-east-1.amazonaws.com/prod",
        CLASSACTIVITYRDS: "https://7fs6aklj1g.execute-api.us-east-1.amazonaws.com/prod",
        CLASSRDS: "https://pxqs2zgqv9.execute-api.us-east-1.amazonaws.com/prod",
        CLASSQUIZZESRDS: "https://jr8z321598.execute-api.us-east-1.amazonaws.com/prod",
        DIFFERENTIATIONRDS: "https://fwthwplzbg.execute-api.us-east-1.amazonaws.com/prod",
        DISTRICTSRDS: "https://bfcfnvyhw8.execute-api.us-east-1.amazonaws.com/prod",
        INTERACTIONRDS: "https://4hj8yp5udg.execute-api.us-east-1.amazonaws.com/prod",
        USERRDS: "https://dmdi98kjvl.execute-api.us-east-1.amazonaws.com/prod",
        NOTESRDS: "https://mqkxxvc4w5.execute-api.us-east-1.amazonaws.com/prod",
        ORGANIZATIONRDS: "https://nivc2qm4rd.execute-api.us-east-1.amazonaws.com/prod",
        QUIZZERDS: "https://a2wx0mki2i.execute-api.us-east-1.amazonaws.com/prod",
        SCHOOLSRDS: "https://mqt7hmdi5e.execute-api.us-east-1.amazonaws.com/prod",
        TIPSRDS: "https://jpc2824soi.execute-api.us-east-1.amazonaws.com/prod",
        USERBOOKSRDS: "https://cmbv0r2mbf.execute-api.us-east-1.amazonaws.com/prod",
        USERCLASSESRDS: "https://dppekc2oob.execute-api.us-east-1.amazonaws.com/prod",
        USERS_PREFERENCE_RDS: "https://8wikn1c0id.execute-api.us-east-1.amazonaws.com/prod",
        SUBMISSIONSRDS: "https://4qrre6rmgb.execute-api.us-east-1.amazonaws.com/prod",
        SCHOOLOGY: "https://du0lnkn7dk.execute-api.us-east-1.amazonaws.com/prod",
        SCHOOLOGY_RDS: "https://72ol2r1qrk.execute-api.us-east-1.amazonaws.com/prod",
        FEEDBACK_RDS: "https://7dn2ai43g4.execute-api.us-east-1.amazonaws.com/prod",
        LOGSRDS: "https://362oyibeh3.execute-api.us-east-1.amazonaws.com/prod",
        CLASSLINKRDS: "https://rpycuyt503.execute-api.us-east-1.amazonaws.com/prod",
        EMAILSERVICE: "https://oviiyvkm5b.execute-api.us-east-1.amazonaws.com/prod",
        PASTSUBMISSIONS: "https://t9tf5foq20.execute-api.us-east-1.amazonaws.com/prod",
        BOOKUNITS: 'https://1bxrhez287.execute-api.us-east-1.amazonaws.com/prod',
        ORGPERMISSIONS: "https://j9prza1h51.execute-api.us-east-1.amazonaws.com/prod",
        RESOURCES: "https://sab3d08hdg.execute-api.us-east-1.amazonaws.com/prod",
        KEYSTORE: 'https://yd96yl1ql2.execute-api.us-east-1.amazonaws.com/prod',
        CLEVER: "https://66d9z2ivwh.execute-api.us-east-1.amazonaws.com/prod",
        BOOKMARKS: "https://r17tzfianf.execute-api.us-east-1.amazonaws.com/prod",
        WS: "wss://85kwykdvs8.execute-api.us-east-1.amazonaws.com/production",
        CHAT: "https://gnsemo1860.execute-api.us-east-1.amazonaws.com/prod",
        EXAMS: ' https://sjmjhfmp6f.execute-api.us-east-1.amazonaws.com/prod',
        INSTRUCTIONS: "https://putl56wh0e.execute-api.us-east-1.amazonaws.com/prod",
        ASSIGNMENT: "https://52uniq9rf9.execute-api.us-east-1.amazonaws.com/prod",
        GOOGLE_CLASSROOM: "https://jfdi3cp0l2.execute-api.us-east-1.amazonaws.com/prod",
        CANVAS: "https://iu6enj9fdj.execute-api.us-east-1.amazonaws.com/prod",
        NOTIFICATION: 'https://zv7ywpnl29.execute-api.us-east-1.amazonaws.com/prod',
        STORY: "https://2tlsu10aa8.execute-api.us-east-1.amazonaws.com/prod",
        APEXAMS: "https://m8okhqrlvi.execute-api.us-east-1.amazonaws.com/prod",
        STANDARDEXAMS: "https://sjmjhfmp6f.execute-api.us-east-1.amazonaws.com/prod",
        HOWTOVIDEOS: 'https://6nw22y03f1.execute-api.us-east-1.amazonaws.com/prod',
        LICENCES: 'https://rz8bfloylj.execute-api.us-east-1.amazonaws.com/prod',
        VOCABULARY: "https://8c9l6d0v77.execute-api.us-east-1.amazonaws.com/prod",
        BEDROCK: 'https://5ymai1zjq7.execute-api.us-east-1.amazonaws.com/prod',
        ONEGAME:'https://c7avbux13g.execute-api.us-east-1.amazonaws.com/prod',
        ONEWAYTEACHER_VIDEO: 'https://bdzplnsltd.execute-api.us-east-1.amazonaws.com/prod',
        ONE_GAME_VIDEO: 'https://9xwncd38ce.execute-api.us-east-1.amazonaws.com/prod',
        ONE_WAY_DEBATE: 'https://pcad60b6vb.execute-api.us-east-1.amazonaws.com/prod',
        ONEGAME:'https://c7avbux13g.execute-api.us-east-1.amazonaws.com/prod',
        FIREBASE: 'https://osegmheyk6.execute-api.us-east-1.amazonaws.com/prod',
        WIDGETS: 'https://a55qv7thj9.execute-api.us-east-1.amazonaws.com/prod',
        SUPER_LESSON: 'https://baxtb4530l.execute-api.us-east-1.amazonaws.com/prod',
        FAVOURITE_VIDEO: 'https://k3wiy1dfqh.execute-api.us-east-1.amazonaws.com/prod',
        EBOOK_HIGHLIGHT:'https://jtw1bqjuze.execute-api.us-east-1.amazonaws.com/prod',
        DIFFERENTIATION_LESSON: 'https://ribnuw4wtf.execute-api.us-east-1.amazonaws.com/prod',
        RUBRIC: "https://ufbhbk72l2.execute-api.us-east-1.amazonaws.com/prod",
        ONE_GAME_GALLERY: 'https://hqaek6p31m.execute-api.us-east-1.amazonaws.com/prod',
        ONE_GAME_CATEGORY: 'https://d533l3fen7.execute-api.us-east-1.amazonaws.com/prod',
        NON_NATIVE_EBOOK_HIGHLIGHT: "https://2sz2kvrj95.execute-api.us-east-1.amazonaws.com/prod",
        ONE_WAY_BINGO: 'https://8s2xx75sjf.execute-api.us-east-1.amazonaws.com/prod',
        STORY_AI_CONFIG: 'https://bbvsxqjlj5.execute-api.us-east-1.amazonaws.com/prod',
        WHATS_NEW: 'https://q92wp20bm1.execute-api.us-east-1.amazonaws.com/prod',
        STUDENT_GROUP: "https://ad8tccju38.execute-api.us-east-1.amazonaws.com/prod",
        AI_BASE_URL:"https://aitest.nosotrosonline.com",
        AI_BASE_NODE_URL:"https://autologin.nosotrosonline.com/api",
        LESSON_PLAN:'https://clvsm4ky86.execute-api.us-east-1.amazonaws.com/prod',
        PERMISSIONS_RDS: "https://o7pduegic9.execute-api.us-east-1.amazonaws.com/prod",
        // AI_BASE_NODE_URL:"http://localhost:4000"
    },
    cognito: {
        REGION: import.meta.env.VITE_REGION,
        USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
        APP_CLIENT_ID: import.meta.env.VITE_APP_CLIENT_ID,
        IDENTITY_POOL_ID: import.meta.env.VITE_IDENTITY_POOL_ID,
    },
    isDev: true,
    sentry_dns:"https://8916602903cb522f4ee51eb915c9120c@o426683.ingest.us.sentry.io/4508522638213120",
    sentry_dns_stg:"https://37d64f4973a2494ba21f016c0e80872c@o426683.ingest.us.sentry.io/5369949"
}

const prod = {
    apiGateway: {
        REGION: "us-east-1",
        ACTIVITYRDS: "https://db2ixkiraa.execute-api.us-east-1.amazonaws.com/prod",
        BOOKSRDS: "https://4ronru96v8.execute-api.us-east-1.amazonaws.com/prod",
        CLASSACTIVITYRDS:
            "https://sc8dd6jjaj.execute-api.us-east-1.amazonaws.com/prod",
        CLASSRDS: "https://vqnepb7wr7.execute-api.us-east-1.amazonaws.com/prod",
        CLASSQUIZZESRDS:
            "https://ib1826viz2.execute-api.us-east-1.amazonaws.com/prod",
        DIFFERENTIATIONRDS:
            "https://6fgegycr1d.execute-api.us-east-1.amazonaws.com/prod",
        DISTRICTSRDS: "https://0m3vndgcei.execute-api.us-east-1.amazonaws.com/prod",
        INTERACTIONRDS:
            "https://7pnjeeqth7.execute-api.us-east-1.amazonaws.com/prod",
        USERRDS: "https://8mddprsm71.execute-api.us-east-1.amazonaws.com/prod",
        NOTESRDS: "https://p029sqb8e0.execute-api.us-east-1.amazonaws.com/prod",
        ORGANIZATIONRDS:
            "https://x7mop4lafd.execute-api.us-east-1.amazonaws.com/prod",
        QUIZZERDS: "https://19ijjuhpzl.execute-api.us-east-1.amazonaws.com/prod",
        SCHOOLSRDS: "https://a0pz0mbezc.execute-api.us-east-1.amazonaws.com/prod",
        TIPSRDS: "https://on1j2zk7x5.execute-api.us-east-1.amazonaws.com/prod",
        USERBOOKSRDS: "https://wz6k94dha7.execute-api.us-east-1.amazonaws.com/prod",
        USERCLASSESRDS:
            "https://7l2v116635.execute-api.us-east-1.amazonaws.com/prod",
        USERS_PREFERENCE_RDS:
            "https://ervml5stsa.execute-api.us-east-1.amazonaws.com/prod",
        SUBMISSIONSRDS:
            "https://p853s7iafl.execute-api.us-east-1.amazonaws.com/prod",
        SCHOOLOGY: "https://du0lnkn7dk.execute-api.us-east-1.amazonaws.com/prod",
        SCHOOLOGY_RDS: "https://5eku0o30bg.execute-api.us-east-1.amazonaws.com/prod",
        FEEDBACK_RDS: "https://pvnprpfd04.execute-api.us-east-1.amazonaws.com/prod",
        LOGSRDS: "https://uonrbv5b82.execute-api.us-east-1.amazonaws.com/prod",
        CLASSLINKRDS: "https://wo0xw3f08c.execute-api.us-east-1.amazonaws.com/prod",
        EMAILSERVICE: "https://nthjhxy573.execute-api.us-east-1.amazonaws.com/prod",
        PASTSUBMISSIONS:
            "https://4r5dwq2me5.execute-api.us-east-1.amazonaws.com/prod",
        BOOKUNITS: "https://10gpx17eu8.execute-api.us-east-1.amazonaws.com/prod",
        ORGPERMISSIONS:
            "https://ztpdf2up6g.execute-api.us-east-1.amazonaws.com/prod",
        RESOURCES: "https://2kgesw4fne.execute-api.us-east-1.amazonaws.com/prod",
        KEYSTORE: "https://5sethuxvth.execute-api.us-east-1.amazonaws.com/prod",
        CLEVER: "https://kme2vx5k15.execute-api.us-east-1.amazonaws.com/prod",
        BOOKMARKS: "https://uz03uzqcyh.execute-api.us-east-1.amazonaws.com/prod",
        WS: "wss://5kata7w641.execute-api.us-east-1.amazonaws.com/production",
        CHAT: "https://acl3xu9sma.execute-api.us-east-1.amazonaws.com/prod",
        EXAMS: "https://uthskp60l0.execute-api.us-east-1.amazonaws.com/prod",
        INSTRUCTIONS: "https://89q6ak1me2.execute-api.us-east-1.amazonaws.com/prod",
        ASSIGNMENT: "https://6nk8kuviv3.execute-api.us-east-1.amazonaws.com/prod",
        GOOGLE_CLASSROOM:
            "https://v8vpelhx80.execute-api.us-east-1.amazonaws.com/prod",
        CANVAS: "https://i6ttug2cuh.execute-api.us-east-1.amazonaws.com/prod",
        STORY: "https://0xkemhub36.execute-api.us-east-1.amazonaws.com/prod",
        APEXAMS: "https://v7trahe1zc.execute-api.us-east-1.amazonaws.com/prod",
        STANDARDEXAMS: "https://uthskp60l0.execute-api.us-east-1.amazonaws.com/prod",
        HOWTOVIDEOS: "https://nvtr1h6xw5.execute-api.us-east-1.amazonaws.com/prod",
        LICENCES: "https://q3ahl30901.execute-api.us-east-1.amazonaws.com/prod",
        NOTIFICATION: "https://y3y3p46j00.execute-api.us-east-1.amazonaws.com/prod",
        VOCABULARY: "https://49y4ca8ukg.execute-api.us-east-1.amazonaws.com/prod",
        BEDROCK: 'https://nhcucskab4.execute-api.us-east-1.amazonaws.com/prod',
        ONEGAME:'',
        ONEWAYTEACHER_VIDEO: 'https://wodn3djtza.execute-api.us-east-1.amazonaws.com/prod',
        ONE_GAME_VIDEO: 'https://2lc8bq6mz4.execute-api.us-east-1.amazonaws.com/prod',
        ONEGAME:'https://mxbosn0tw8.execute-api.us-east-1.amazonaws.com/prod',
        ONE_WAY_DEBATE: 'https://ftilcxxzdi.execute-api.us-east-1.amazonaws.com/prod',
        FIREBASE: 'https://ln7vzulfm8.execute-api.us-east-1.amazonaws.com/prod',
        WIDGETS: 'https://5ntl0inx9i.execute-api.us-east-1.amazonaws.com/prod',
        SUPER_LESSON: 'https://989g109njg.execute-api.us-east-1.amazonaws.com/prod',
        FAVOURITE_VIDEO: 'https://6orlbu8bt0.execute-api.us-east-1.amazonaws.com/prod',
        EBOOK_HIGHLIGHT:'https://2hfcat7asc.execute-api.us-east-1.amazonaws.com/prod',
        DIFFERENTIATION_LESSON: 'https://37v0v4uhc4.execute-api.us-east-1.amazonaws.com/prod',
        RUBRIC: "https://oe2f90ac5c.execute-api.us-east-1.amazonaws.com/prod",
        ONE_GAME_GALLERY: 'https://4lnr2o2jqd.execute-api.us-east-1.amazonaws.com/prod',
        ONE_GAME_CATEGORY: 'https://qt5lpt861f.execute-api.us-east-1.amazonaws.com/prod',
        NON_NATIVE_EBOOK_HIGHLIGHT: "https://7ddkpwnj20.execute-api.us-east-1.amazonaws.com/prod",
        ONE_WAY_BINGO: 'https://1eo1dw09c9.execute-api.us-east-1.amazonaws.com/prod',
        STORY_AI_CONFIG: 'https://cm7mqnzf8k.execute-api.us-east-1.amazonaws.com/prod',
        WHATS_NEW: 'https://5a5ttw6cog.execute-api.us-east-1.amazonaws.com/prod',
        STUDENT_GROUP: "https://c00zgeyrig.execute-api.us-east-1.amazonaws.com/prod",
        AI_BASE_URL:"https://ai.nosotrosonline.com",
        AI_BASE_NODE_URL:"https://autologin.nosotrosonline.com/api",
        LESSON_PLAN:'https://0zzrrk0xh0.execute-api.us-east-1.amazonaws.com/prod',
        PERMISSIONS_RDS: "https://szuholv3f5.execute-api.us-east-1.amazonaws.com/prod",
        // AI_BASE_NODE_URL:"http://localhost:4000"
    },
    cognito: {
        REGION: import.meta.env.VITE_REGION,
        USER_POOL_ID: import.meta.env.VITE_PRD_USER_POOL_ID,
        APP_CLIENT_ID: import.meta.env.VITE_PRD_APP_CLIENT_ID,
        IDENTITY_POOL_ID: import.meta.env.VITE_PRD_IDENTITY_POOL_ID,
    },
    isDev: false,
    sentry_dns:"https://98a44ef73c7ab903df9514414da16861@o426683.ingest.us.sentry.io/4508040028356608",
    sentry_dns_stg:"https://37d64f4973a2494ba21f016c0e80872c@o426683.ingest.us.sentry.io/5369949"
};


const config = import.meta.env.VITE_APP_STAGE?.trim() === 'prod'
    ? prod
    : dev;
const LOCAL_GAME_ENABLE = false;
export default {
    G_CLIENT_ID:"427835405630-c85sahn2l7a40s2muj1pjku0b1ujbtmk.apps.googleusercontent.com",
    ONEGAME_COMPANY_ID: import.meta.env.VITE_ONEGAME_COMPANY_ID,
    is_local: LOCAL_GAME_ENABLE && (window.location.href.includes("192") || window.location.href.includes("localhost")),
    ...config
};


